exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-blue-onfly[data-v-7abe9c5c]{color:#1976d2}.text-secondary[data-v-7abe9c5c]{color:rgba(84,102,122,.7)!important;font-weight:500!important}.container[data-v-7abe9c5c]{width:80%}@media (max-width:6768px){.container[data-v-7abe9c5c]{width:90%}}", ""]);

// exports
